import { z } from 'zod';

const alignmentBulkRunReasonSchema = z.object({
    kind: z.string().nullish(),
    code: z.string().nullish(),
    message: z.string().nullish(),
});

const alignmentBulkRunItemSchema = z.object({
    alignmentId: z.string().nullish(),
    employeeId: z.string().nullish(),
    title: z.string().nullish(),
    status: z.string().nullish(),
    reason: alignmentBulkRunReasonSchema.nullish(),
});

export type AlignmentBulkRunItem = z.infer<typeof alignmentBulkRunItemSchema>;

/**
 * Progress and result of one run that starts alignments for several people. Every emission of a run carries the same
 * `blockId`, so the latest one is the state of the run. Action and status stay strings: a value this client does not
 * know must not drop the card.
 */
export const alignmentBulkRunProgressBlockSchema = z.object({
    type: z.literal('alignment-bulk-run-progress'),
    blockId: z.string(),
    action: z.string().nullish(),
    status: z.string().nullish(),
    total: z.number().nullish(),
    done: z.number().nullish(),
    succeeded: z.number().nullish(),
    failed: z.number().nullish(),
    skipped: z.number().nullish(),
    items: z.array(alignmentBulkRunItemSchema).nullish(),
    itemsTruncated: z.boolean().nullish(),
});

export type AlignmentBulkRunProgressBlock = z.infer<typeof alignmentBulkRunProgressBlockSchema>;
